import { useCallback, useEffect, useState } from "react";
import http from "../../../../http";
import { useRecarregaAoRenovarToken } from "../../../shared/hooks/useRecarregaAoRenovarToken";

export const useBuscaListaDeIdsDeOcorrenciasSemLaudo = () => {
    const [listaIdsDeOcorrenciaSemLaudo, setListaIdsDeOcorrenciasSemLaudo] = useState([])

    const buscaListaDeIdsDeOcorrenciasSemLaudo = useCallback(() => {
        http.get('/ocorrencias-sem-laudo')
        .then(res => {
            const listaOcorrencias = res.data
            setListaIdsDeOcorrenciasSemLaudo(listaOcorrencias)
        })
        .catch(() => setListaIdsDeOcorrenciasSemLaudo([]))
    }, [])

    useEffect(() => {
        buscaListaDeIdsDeOcorrenciasSemLaudo()
    }, [buscaListaDeIdsDeOcorrenciasSemLaudo])

    useRecarregaAoRenovarToken(buscaListaDeIdsDeOcorrenciasSemLaudo)

    return {
        listaIdsDeOcorrenciaSemLaudo
    }
}
